import { createBaseInputNamespace } from '../BaseInput';
import { InputTypes } from '../enums/InputTypes';

export const TextInput = createBaseInputNamespace(InputTypes.Text);
